import React from "react";
import classes from './DesktopFilters.module.css'
import CleanSearch from "../../../shared/filters/cleanSearch/CleanSearch";
import FiltersSelects from "../../../shared/filters/filtersSelects/FiltersSelects";

const DesktopFilters = ({ setFilters, filters }) => {


    return (
        <div className={classes.Filters}>
            <div className={classes.FiltersLine}>
                <FiltersSelects setFilters={setFilters} filters={filters} />
                <CleanSearch setFilters={setFilters} />
            </div>
        </div>
    )
}

export default DesktopFilters